export default {
    reset_password_title: "Reset Password",
    current_password: "Current password",
    new_password: "New password",
    repeat_new_password: "Repeat new password",
    save: "Save",
    fill_all_fields: "Please fill in all fields",
    passwords_dont_match: "Password and repeat password fields do not match",
    wrong_password: "The password provided is incorrect",
    password_changed_success: "Password changed successfully.",
    page_title: "Kevi | Reset Password",
    two_factor: {
        title: "2FA Authentication",
        setup_title: "Setup Two-Factor Authentication",
        scan_instruction:
            "Scan the QR Code with your Authenticator App to proceed to the next steps",
        scanned_button: "I've scanned it",
        enter_code_title: "Enter verification code",
        verify_code_placeholder: "Verification code",
        validate_button: "Validate Code",
        backup_codes_title: "Your backup codes",
        backup_important_message:
            "These codes are important and will not appear again. Write them down in a safe place in case you lose your device.",
        copy_instruction:
            'Click "Copy Codes" to copy all codes at once and be able to return.',
        copy_codes_button: "Copy Codes",
        back_button: "Back",
        copy_success: "Codes copied successfully!",
        invalid_code: "Invalid code!",
        error_qr: "Error generating QR Code",
        error_backup: "Error generating backup codes",
    },
    rewards: {
        title: "Kevi Loyalty",
        points: "points",
        points_label: "Points",
        use_now: "Use now",
        support_contact: "To use, contact support",
        missing: "Missing",
        missing_one: "1 point missing",
        page_title: "My points",
        confirm_redeem: "Are you sure you want to redeem your reward?",
        redeem_success: "Reward redeemed successfully!",
    },
};
